import React, { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect} from 'react';
import { trackEvent } from '../firebaseAnalytics';
import { useTheme } from '../theme/ThemeProvider';
import LaunchCta from './LaunchCta';

export default function NavBar(){
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobileMenu = useCallback(()=>{
    setMobileOpen(false);
  }, []);

  function toggleMobileMenu(){ setMobileOpen(v => !v); }

  useEffect(()=>{ 
    document.body.classList.toggle('mobile-open', mobileOpen);

    function onResize(){ 
      if(window.innerWidth > 900 && mobileOpen){ 
        closeMobileMenu();
      } 
    } 
    function onKeyDown(event){
      if(event.key === 'Escape' && mobileOpen) closeMobileMenu();
    }
    window.addEventListener('resize', onResize); 
    window.addEventListener('keydown', onKeyDown);
    return ()=>{
      window.removeEventListener('resize', onResize);
      window.removeEventListener('keydown', onKeyDown);
      document.body.classList.remove('mobile-open');
    };
  }, [closeMobileMenu, mobileOpen]);
  
  
  const goToSection = useCallback((id)=>{
    const el = document.getElementById(id);
    if(el){ el.scrollIntoView({behavior:'smooth', block:'start'}); }
  }, []);

  const handleSectionNav = useCallback((e, id)=>{
    e.preventDefault();
    const isLanding = typeof window !== 'undefined' && window.location.pathname === '/';
    if(isLanding){
      goToSection(id);
    } else {
      navigate('/', { state: { scrollToId: id } });
    }
    closeMobileMenu();
  }, [closeMobileMenu, goToSection, navigate]);

  const handleBrandClick = useCallback((e)=>{
    handleSectionNav(e, 'top');
  }, [handleSectionNav]);

  return (
    <header className={mobileOpen ? 'nav burger' : 'nav'}>
      <div>
        <div className="container nav-inner">
          <a href="/#top" className="brand" onClick={handleBrandClick}>
            <img src="Icon/Final%20Logos/Logo_Transparent_Favicon_Large.png" alt="Promptera logo" className="logo" style={{background:'transparent',width:38,height:38,border:'none',boxShadow:'none',borderRadius:0,padding:0,objectFit:'contain'}}/>
            <span style={{fontFamily:'-apple-system, BlinkMacSystemFont, "SF Pro Display", "Inter", "Helvetica Neue", Arial, sans-serif',fontSize:'1.55rem',fontWeight:750,letterSpacing:0,background:'linear-gradient(to top left, rgb(140,93,255), rgb(83,27,189))',WebkitBackgroundClip:'text',backgroundClip:'text',color:'transparent'}}>Promptera</span>
          </a>
          <nav className={mobileOpen ? 'mobile-open' : ''}>
            <ul>
              <li><a href="/#features" onClick={(e) => handleSectionNav(e, 'features')}>Features</a></li>
              <li><a href="/#pricing" onClick={(e)=> handleSectionNav(e,'pricing')}>Pricing</a></li>
              <li><Link to="/changelog" onClick={closeMobileMenu}>Changelog</Link></li>
              <li><Link to="/blog" onClick={closeMobileMenu}>Blog</Link></li>
              {/* <li><a href="/#team" onClick={(e)=> handleSectionNav(e,'team')}>Team</a></li> */}
              <li>
                <Link
                  to="/contact"
                  onClick={()=>{
                    trackEvent('contact_click', { source: 'nav', destination: 'contact_page' });
                    closeMobileMenu();
                  }}
                >
                  Contact
                </Link>
              </li>
              <li><Link to="/faq" onClick={closeMobileMenu}>FAQ</Link></li>
            </ul>
            <div className="mobile-menu-actions">
              <LaunchCta
                className="mobile-menu-cta"
                onClick={()=>{
                  closeMobileMenu();
                }}
                source="mobile_nav"
              />
              <button
                className="theme-toggle mobile-theme-toggle"
                type="button"
                onClick={toggleTheme}
                aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
                aria-pressed={theme === 'light'}
                title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
              >
                <i className={`theme-toggle-icon fi ${theme === 'dark' ? 'fi-rr-sun' : 'fi-rr-moon'}`} aria-hidden="true" />
              </button>
            </div>
          </nav>
          <div className="nav-cta">
            <LaunchCta
              className='btn-waitlist'
              onClick={()=>{
                closeMobileMenu();
              }}
              source="nav"
            />
            <button className="nav-burger" aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} onClick={toggleMobileMenu} type="button">
                <span className="burger-box">
                <span className="burger-inner" aria-hidden="true"></span>
              </span>
            </button>
            <button
              className="theme-toggle theme-toggle-desktop"
              type="button"
              onClick={toggleTheme}
              aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
              aria-pressed={theme === 'light'}
              title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
            >
              <i className={`theme-toggle-icon fi ${theme === 'dark' ? 'fi-rr-sun' : 'fi-rr-moon'}`} aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
